<template>
    <v-container fluid grid-list-xs
            :data-watch-loader="watchLoader">
        <v-layout v-if="!isLoaded" justify-center align-center fill-height>
            <loader></loader>
        </v-layout>
        <v-layout row wrap v-else class="height-100-vh">
            <v-flex xs12 pb-3 v-if="agency || employee || createdBy || machine || client || startDate || endDate || status !== null || action !== null">
                <v-layout row wrap justify-start>
                  <v-chip v-if="agency" v-model="agencyChip" close>Sucursală: {{agency.name}}</v-chip>
                  <v-chip v-if="employee" v-model="employeeChip" close>Angajat: {{employee.name}}</v-chip>
                  <v-chip v-if="createdBy" v-model="createdByChip" close>Înregistrată de: {{createdBy.name}}</v-chip>
                  <v-chip v-if="machine" v-model="machineChip" close>Aparat: {{machine.idstr}}</v-chip>
                  <v-chip v-if="client" v-model="clientChip" close>Client: {{client.name}}</v-chip>
                  <v-chip v-if="status !== null" v-model="statusChip" close>Stare: {{status.name}}</v-chip>
                  <v-chip v-if="action !== null" v-model="actionChip" close>Acțiune: {{getActionName(action)}}</v-chip>
                  <v-chip v-if="startDate" v-model="startDateChip" close>Dată început: {{startDate}}</v-chip>
                  <v-chip v-if="endDate" v-model="endDateChip" close>Dată sfârșit: {{endDate}}</v-chip>
                </v-layout>
            </v-flex>
            <pull-to :top-load-method="refresh" :top-config="pullDownConfig"	>
              <v-tabs-items v-model="tab">
                <v-tab-item v-for="tabItem in $store.state.visits.tabItems" :key="tabItem.id">
                  <v-flex @click="goToVisit(item)" xs12 v-for="(item, index) in getTabItems(tabItem.id)" :key="index">
                      <visit-card :visit="item"></visit-card>
                  </v-flex>
                  <v-flex v-if="items.length === 0 || getTabItems(tabItem.id).length === 0">
                    <p class="headline text-xs-center">Nu a fost găsită nici o vizită {{`${tabItem.id ? 'efectuată' : 'programată'}`}}</p>
                  </v-flex>
                  <v-flex v-if="items.length" xs12>
                    <infinite-loading @infinite="infiniteHandler" :distance="200" ref="infiniteLoading">
                      <span slot="spinner">
                        <loader></loader>
                      </span>
                      <span slot="no-more">
                        <p>~</p>
                      </span>
                    </infinite-loading>
                  </v-flex>
                </v-tab-item>
              </v-tabs-items>
            </pull-to>
            <v-btn fab bottom right color="pink" dark fixed @click.stop="addVisit()" >
              <v-icon>add</v-icon>
            </v-btn>
            <edit-dialog v-if="dialogData"
              entityName="Vizită"
              :fields="fields"
              :isMobile="true"
              :fieldValues="dialogData"
              @status="onStatusChange"
              :apiEndpoint="apiEndpoint">
            </edit-dialog>
        </v-layout>
        <v-layout v-if="dialog" row justify-center>
            <v-dialog v-model="dialog" persistent
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition">
                <v-card>
                    <v-card-title>
                        <v-toolbar dark color="pink" card fixed>
                          <v-btn icon dark @click.native="dialog = false">
                            <v-icon>close</v-icon>
                          </v-btn>
                          <v-toolbar-title>Filtrare</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn dark flat
                                @click.native="filterVisits()"
                                :loading="!isLoaded"
                                :disabled="!isLoaded">Filtrează</v-btn>
                          </v-toolbar-items>
                        </v-toolbar>
                    </v-card-title>
                      <v-container grid-list-md mt-4>
                          <v-layout wrap>
                              <v-flex xs12>
                                  <v-layout row justify-start wrap>
                                      <v-flex xs4 sm3>
                                        <v-subheader>Sucursală</v-subheader>
                                      </v-flex>
                                      <v-flex xs8 sm7>
                                        <v-select
                                          :items="$store.state.agencies.data"
                                          item-text="name"
                                          v-model="agencyDialog"
                                          label="Select"
                                          single-line
                                          return-object
                                        >
                                        </v-select>
                                      </v-flex>
                                  </v-layout>
                                  <v-layout row justify-start wrap>
                                      <v-flex xs4 sm3>
                                        <v-subheader>Angajat</v-subheader>
                                      </v-flex>
                                      <v-flex xs8 sm7>
                                        <v-select
                                          :items="$store.state.employees.data"
                                          v-model="employeeDialog"
                                          label="Select"
                                          single-line
                                        >
                                            <template slot="selection" slot-scope="data">
                                              {{`${data.item.name}`}}
                                            </template>
                                            <template slot="item" slot-scope="data">
                                              <template v-if="typeof data.item !== 'object'">
                                                <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                              </template>
                                              <template v-else>
                                                  <v-list-tile-content v-text="`${data.item.name}`"></v-list-tile-content>
                                              </template>
                                            </template>
                                        </v-select>
                                      </v-flex>
                                  </v-layout>
                                  <v-layout row justify-start wrap>
                                      <v-flex xs4 sm3>
                                        <v-subheader>Înregistrată de</v-subheader>
                                      </v-flex>
                                      <v-flex xs8 sm7>
                                        <v-select
                                            :items="$store.state.employees.data"
                                            v-model="createdByDialog"
                                            item-text="name"
                                            label="Select"
                                            single-line
                                            return-object
                                          >
                                        </v-select>
                                      </v-flex>
                                  </v-layout>
                                  <v-layout row justify-start wrap>
                                      <v-flex xs4 sm3>
                                        <v-subheader>Aparat</v-subheader>
                                      </v-flex>
                                      <v-flex xs8 sm7>
                                          <autocomplete-selector
                                            :items="$store.state.machines.data"
                                            item-text="idstr"
                                            item-value="id"
                                            v-model="machineDialog"
                                            label="Select"
                                            :return-object="true"
                                            apiEndpoint="machines"
                                          />
                                      </v-flex>
                                  </v-layout>
                                  <v-layout row justify-start wrap>
                                      <v-flex xs4 sm3>
                                        <v-subheader>Client</v-subheader>
                                      </v-flex>
                                      <v-flex xs8 sm7>
                                        <autocomplete-selector
                                          :items="$store.state.clients.data"
                                          item-text="name"
                                          item-value="id"
                                          v-model="clientDialog"
                                          label="Select"
                                          :return-object="true"
                                          apiEndpoint="clients"
                                        />
                                      </v-flex>
                                  </v-layout>
                                  <v-layout row justify-start wrap>
                                      <v-flex xs12 sm3>
                                        <v-subheader v-model="status">Acțiune</v-subheader>
                                      </v-flex>
                                      <v-flex xs12 sm7>
                                        <action-selector v-model="actionDialog"/>
                                      </v-flex>
                                  </v-layout>
                                  <v-layout row justify-start wrap>
                                      <v-flex xs12 sm3>
                                          <v-subheader>Perioada</v-subheader>
                                      </v-flex>
                                      <v-flex xs12 sm7>
                                          <v-layout row wrap>
                                              <v-flex xs12 sm6>
                                                  <v-menu
                                                    ref="startDateDialog"
                                                    :close-on-content-click="false"
                                                    v-model="startDateModal"
                                                    :nudge-right="40"
                                                    :return-value.sync="startDate"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                                  >
                                                    <v-text-field
                                                      slot="activator"
                                                      v-model="startDateDialog"
                                                      label="Dată început"
                                                      prepend-icon="event"
                                                      readonly
                                                    ></v-text-field>
                                                    <v-date-picker v-model="startDate" @input="$refs.startDateDialog.save(startDate)" :max="endDate"></v-date-picker>
                                                  </v-menu>
                                              </v-flex>
                                              <v-flex xs12 sm6>
                                                  <v-menu
                                                    ref="endDateDialog"
                                                    :close-on-content-click="false"
                                                    v-model="endDateModal"
                                                    :nudge-right="40"
                                                    :return-value.sync="endDate"
                                                    lazy
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                                  >
                                                    <v-text-field
                                                      slot="activator"
                                                      v-model="endDateDialog"
                                                      label="Dată sfârșit"
                                                      prepend-icon="event"
                                                      readonly
                                                    ></v-text-field>
                                                    <v-date-picker v-model="endDate" @input="$refs.endDateDialog.save(endDate)" :min="startDate"></v-date-picker>
                                                  </v-menu>
                                              </v-flex>
                                          </v-layout>
                                      </v-flex>

                                  </v-layout>
                              </v-flex>
                          </v-layout>
                      </v-container>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>

<script>
import VisitCard from './VisitCard';
import ActionSelector from './ActionSelector';
import moment from 'moment';
import InfiniteLoading from 'vue-infinite-loading';
import * as constants from '../constants';
import AutocompleteSelector from './AutocompleteSelector';
import PullTo from 'vue-pull-to';

export default {
  components: {
    VisitCard,
    ActionSelector,
    InfiniteLoading,
    AutocompleteSelector,
    PullTo
  },

  data() {
    return {
      entityName: 'Vizită',
      apiEndpoint: 'visits',
      isLoaded: false,
      dialogData: null,
      startDateModal: false,
      endDateModal: false,
      startDate: null,
      endDate: null,
      agency: null,
      employee: null,
      createdBy: null,
      machine: null,
      client: null,
      status: null,
      action: null,
      startDateDialog: null,
      endDateDialog: null,
      agencyDialog: null,
      employeeDialog: null,
      createdByDialog: null,
      machineDialog: null,
      clientDialog: null,
      statusDialog: null,
      actionDialog: null,
      currentPage: 1,
      filter: {},
      pagination: {},
      rowsPerPage: constants.ROWS_PER_PAGE,
      totalItems: 0,
      pullDownConfig: constants.TOP_DEFAULT_CONFIG
    };
  },

  computed: {
    getTabItems() {
      return (id) => {
        return this.items.filter(f => f.status === id).sort((a, b) => {
          if (new Date(b.created_at) > new Date(a.created_at)) {
            return id ? 1 : -1;
          }
          if (new Date(b.created_at) < new Date(a.created_at)) {
            return id ? -1 : 1;
          }
          return 0;
        });
      };
    },

    tab: {
      get() {
        return this.$store.state.visits.tab;
      },

      set(val) {
        this.$store.commit('visits/TAB', val);
      }
    },

    lastPage() {
      return Math.ceil(this.totalItems / constants.ROWS_PER_PAGE);
    },

    isLastPage() {
      return this.currentPage >= this.lastPage;
    },

    dialog: {
      get() {
        this.startDateDialog = this.startDate;
        this.endDateDialog = this.endDate;
        this.agencyDialog = this.agency;
        this.employeeDialog = this.employee;
        this.createdByDialog = this.createdBy;
        this.machineDialog = this.machine;
        this.clientDialog = this.client;
        this.statusDialog = this.status;
        this.actionDialog = this.action;
        return this.$store.state.visits.filter;
      },
      set(value) {
        this.$store.commit('visits/FILTER', value);
      }
    },

    items() {
      return this.$store.state.visits.data;
    },

    loadedItems() {
      return this.loadedItems.concat(this.items);
    },

    fields() {
      return [
        {
          size: 'sm6',
          label: 'Stare',
          value: 'status',
          type: 'v-select',
          inputType: 'text',
          options: this.$store.state.visits.status,
          required: true
        },
        {
          size: 'sm6',
          label: 'Aparat',
          value: 'machine_id',
          itemText: 'idstr',
          type: 'autocomplete-selector',
          required: true,
          apiEndpoint: 'machines'
        },
        {
          size: 'sm6',
          label: 'Contor general',
          value: 'counter',
          type: 'v-text-field',
          inputType: 'number',
          required: true
        },
        {
          label: 'Note',
          value: 'notes',
          type: 'v-textarea',
          inputType: 'text',
          box: true
        }
      ];
    },

    watchLoader: {
      get() {
        if (this.isLoaded) {
          this.$store.commit('CENTER_VIEW_VERTICAL', false);
        } else {
          this.$store.commit('CENTER_VIEW_VERTICAL', true);
        }
      }
    },

    agencyChip: {
      get() {
        return !!this.agency;
      },
      set(value) {
        if (!value) {
          this.agency = null;
          this.loadItems();
        }
      }
    },

    employeeChip: {
      get() {
        return !!this.employee;
      },
      set(value) {
        if (!value) {
          this.employee = null;
          this.loadItems();
        }
      }
    },

    createdByChip: {
      get() {
        return !!this.createdBy;
      },
      set(value) {
        if (!value) {
          this.createdBy = null;
          this.loadItems();
        }
      }
    },

    machineChip: {
      get() {
        return !!this.machine;
      },
      set(value) {
        if (!value) {
          this.machine = null;
          this.loadItems();
        }
      }
    },

    clientChip: {
      get() {
        return !!this.client;
      },
      set(value) {
        if (!value) {
          this.client = null;
          this.loadItems();
        }
      }
    },

    statusChip: {
      get() {
        return !!this.status;
      },
      set(value) {
        if (!value) {
          this.status = null;
          this.loadItems();
        }
      }
    },

    actionChip: {
      get() {
        return !!this.action;
      },
      set(value) {
        if (!value) {
          this.action = null;
          this.loadItems();
        }
      }
    },

    startDateChip: {
      get() {
        return !!this.startDate;
      },
      set(value) {
        if (!value) {
          this.startDate = null;
          this.loadItems();
        }
      }
    },

    endDateChip: {
      get() {
        return !!this.endDate;
      },
      set(value) {
        if (!value) {
          this.endDate = null;
          this.loadItems();
        }
      }
    }
  },

  created() {
    this.loadDependencies().then(() => {
      this.loadItems();
      this.isLoaded = true;
      // this.loadMoreVisits().then(() => { this.isLoaded = true; });
    });
  },

  watch: {
    filter: {
      handler() {
        this.isLoaded = false;
        this.loadMoreVisits().then((result) => {
          this.currentPage = result.meta.current_page;
          this.isLoaded = true;
        });
      },
      deep: true
    }
  },

  methods: {
    loadItems() {
      this.filter = {
        agency_id: this.agency ? this.agency.id : null,
        employee_id: this.employee ? this.employee.id : null,
        created_by_id: this.createdBy ? this.createdBy.id : null,
        machine_id: this.machine ? this.machine.id : null,
        client_id: this.client ? this.client.id : null,
        status: this.status ? this.status.id : null,
        action_id: this.action ? this.action : null,
        start_date: this.startDate ? moment(this.startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss') : null,
        end_date: this.endDate ? moment(this.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss') : null
      };
    },

    infiniteHandler($state) {
      if (this.isLastPage) {
        $state.loaded();
        $state.complete();
      } else {
        this.loadMoreVisits(true).then((result) => {
          this.currentPage++;
          this.totalItems = result.meta.total;
          $state.loaded();
        }).catch(() => {
          $state.complete();
        });
      }
    },

    loadMoreVisits(loadMore = false) {
      this.pagination = {
        rowsPerPage: this.rowsPerPage,
        page: this.currentPage
      };
      return this.$store.dispatch(`visits/LOAD`, {filter: { ...this.filter, ...this.pagination }, loadMore});
    },

    loadDependencies() {
      return Promise.all([
        this.$store.dispatch('actions/LOAD', {filter: { rowsPerPage: -1 }}),
        this.$store.dispatch('employees/LOAD', {filter: { rowsPerPage: -1 }}),
        this.$store.dispatch('agencies/LOAD', {filter: { rowsPerPage: -1 }})
      ]);
    },

    addVisit() {
      this.dialogData = {
        id: null,
        status: 1,
        created_at: moment(new Date()).local().format('YYYY-MM-DD HH:mm:ss')
      };
    },

    onStatusChange(value) {
      this.dialogData = value;
    },

    goToVisit(item) {
      this.$router.push({ name: 'Visit', params: { id: item.id } });
    },

    getActionName(id) {
      return this.$store.getters['actions/action'](id).path;
    },

    filterVisits() {
      this.startDate = this.startDateDialog;
      this.endDate = this.endDateDialog;
      this.agency = this.agencyDialog;
      this.employee = this.employeeDialog;
      this.createdBy = this.createdByDialog;
      this.machine = this.machineDialog;
      this.client = this.clientDialog;
      this.status = this.statusDialog;
      this.action = this.actionDialog;
      this.loadItems();
      this.dialog = false;
    },

    refresh(loaded) {
      this.loadMoreVisits()
        .then((res) => {
          loaded('done');
        });
    }
  }
};
</script>

<style>
  .height-100-vh {
    min-height: 100vh;
  }
</style>


// WEBPACK FOOTER //
// src/components/VisitsView.vue